import { inventoryApi } from '../api/inventoryApi'
import type { InventoryInTransactionCreateData } from '../schema/inventorySchema'

export const recordInTransaction = async (
  transaction: InventoryInTransactionCreateData,
  invoiceFile?: File,
) => {
  try {
    const { data } = await inventoryApi.createInTransaction(
      transaction,
      invoiceFile,
    )
    return data
  } catch (error) {
    console.error(`Error recording in transaction: `, error)
    throw error
  }
}
